import { createContext, useContext } from 'react';

export interface DataIssuesContextValue {
  /** Chỉ ADMIN thấy liên kết từ tài khoản app sang trang Tài khoản. */
  isAdmin: boolean;
  /**
   * `false` = số tóm tắt đã tải xong và chưa có file nào được nhập; `true` = đã có file;
   * `null` = chưa biết (đang tải hoặc tải lỗi).
   */
  hasData: boolean | null;
  /** Tăng mỗi lần bấm "Tải lại": số tóm tắt và bảng đang mở cùng tải lại. */
  refreshKey: number;
  reload: () => void;
}

export const DataIssuesContext = createContext<DataIssuesContextValue>({
  isAdmin: false,
  hasData: null,
  refreshKey: 0,
  reload: () => undefined,
});

export const useDataIssues = () => useContext(DataIssuesContext);
